"use client";
import React, {Suspense} from "react";
import {Button, VStack, Heading} from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {scrollToElement} from "@/utils/scrollToElement";
import {PRICING_HEADING_CONSTANTS} from "./constants";
import {tablist} from "./pricingTabsList";

const PricingTabs = () => {
  const headingVariant = useSectionHeadingVariant();
  return (
    <VStack id="pricing" spacing={4}>
      <Heading as="h1" variant={headingVariant}>
        {PRICING_HEADING_CONSTANTS.title}
      </Heading>
      <Suspense>
        <Tabs columns={{base: 1, sm: 2}} tabList={tablist} />
      </Suspense>
      <Button
        variant={BUTTON_VARIANTS.IDEAL}
        onClick={() => scrollToElement("contact-us", 120)}
        alignSelf={"center"}
        justifySelf={"center"}
        px={6}
      >
        Ready To Buy?
      </Button>
    </VStack>
  );
};

export default PricingTabs;
